import { createStateContext } from '@change-corgi/core-react/context';

import { mutations } from './mutations';
import type { ContributionsPageState } from './types';

/** @knip-ignore */
export const {
	StateContext: ContributionsPageStateContext,
	StateProvider: ContributionsPageStateContextProvider,
	useStateContext: useContributionsPageState,
} = createStateContext<
	ContributionsPageState,
	typeof mutations,
	{
		subscription: Omit<ContributionsPageState['subscription'], 'formState' | 'validationErrors'>;
	}
>({
	name: 'ContributionsPageStateContext',
	mutations,
	initialState({ subscription }) {
		return {
			subscription: {
				...subscription,
				formState: null,
				validationErrors: null,
			},
			pageMessage: null,
			loadingUpdatePaymentMethod: false,
			selectedPaymentType: 'creditCard',
			userName: '',
			nameErrorMessage: undefined,
			pmUpdatedAt: Date.now(),
		};
	},
});
